import type {
	FieldValidationInput,
	FieldValidator,
	ValidationError,
} from '../../../types/validation.tsx';

export const composeValidators =
	(validators: FieldValidator[]): FieldValidator =>
	(validationInput: FieldValidationInput): ValidationError[] =>
		validators.flatMap((validator) => validator(validationInput));
